import { GwCompanyForm } from "./Main";

export const Register = () => {
  return <GwCompanyForm />;
};
